export const DELETE_PROCESS_STATEMENT_FAILURE = 'DELETE_PROCESS_STATEMENT_FAILURE';

export const deleteProcessStatementFailure = error => ({
    type: DELETE_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
